import { IAnnouncements, announcementsVar } from '@services/graphql/core';
import { ReactiveVar, useReactiveVar } from '@apollo/client';

export function useAnnouncements(): [
  IAnnouncements,
  ReactiveVar<IAnnouncements>,
] {
  return [useReactiveVar(announcementsVar), announcementsVar];
}
